import React from 'react';
import {Link, Redirect} from 'react-router-dom'
import {Form, Button, Input} from 'reactstrap';
import ApiConstants from '../../../constants/ApiConstants';
import Utils from '../../../util';
import { injectIntl, intlShape } from 'react-intl';
import IntlMessages from 'util/IntlMessages';

class ForgotPassword extends React.Component {    
	constructor(props) {
		super(props);
		this.state = {
            email: '',
            success: false
		};
    }    

    onChange = (e) => {
        this.setState({
            email: e.target.value
        });
    }
    
	handleSubmit = (e) => {
		e.preventDefault();
        
        fetch(ApiConstants.getApiPath() + 'api/v1/users/password/forgot', {
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'Authorization': 'Basic ' + Utils.btoa(ApiConstants.getApiClient().client_id + ':' + ApiConstants.getApiClient().client_secret)
            },            
            body: "email="+encodeURIComponent(this.state.email)
        })
        .then(res => {
            if(res.ok) {
                this.setState({
                    success: true
                })
            }
        })
        .catch(error => {
            console.log('error', error);
        })
    }

	render () {    
        const {intl} = this.props;

        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="login-content">
                    <div className="login-header">
                        <Link className="app-logo" to="/" title="BeDaddy">
                            <img src="images/logo.png" alt="BeDaddy" title="BeDaddy"/>
                        </Link>
                    </div>

                    <div className="mb-4">
                        <h2><IntlMessages id="appModule.forgotPassword"/></h2>
                    </div>

                    <div className="login-form">
                        <Form onSubmit={this.handleSubmit}>
                            <div className="form-group mb-3">
                                <Input type="email" name="email" id="email" value={this.state.email} onChange={this.onChange} required placeholder={intl.formatMessage({id: 'pages.contact.email'})}/>
                            </div>

                            <p>
                                <IntlMessages id="appModule.dntRememberEmail"/> &nbsp;
                                <a className="small" href="javascript:void(0)">
                                    <IntlMessages id="appModule.contactSupport"/>
                                </a>
                            </p>

                            <div className="">
                                <Button className="jr-btn btn-primary btn btn-default"><IntlMessages
                                    id="appModule.resetPassword"/></Button>
                            </div>
                        </Form>
                    </div>
                </div>

				{
					this.state.success && <Redirect to="/login"/>
				}                
            </div>
        );
    }
};

ForgotPassword.propTypes = {
	intl: intlShape.isRequired
}

export default injectIntl(ForgotPassword);


// WEBPACK FOOTER //
// ./app/routes/ForgotPassword/index.js